import classNames from 'classnames';
import React, { FC, useState } from 'react';

import { ButtonTypes, SmallButton } from '@eika/button';
import { useViewType, ViewType } from '@eika/hooks';
import { Icon, IconTypes } from '@eika/icon';
import { Link as LinkItem, LinkType } from '@eika/link';

import { Link, MenuItem } from '../MenuTypes';
import ExpandableMenuElement from '../components/ExpandableMenuElement';
import MenuElement from '../components/MenuElement';

export interface NativeMenu {
    items?: MenuItem[];
    logout?: () => void;
    logoutButtonText?: string;
    bankLink: Link | null;
}

const DesktopMenu: FC<NativeMenu> = ({ items = [], bankLink, logout, logoutButtonText }) => {
    const viewType = useViewType();
    const isPadStart = viewType !== ViewType.mobile;
    const hideMenu = !items?.length && isPadStart;
    const [isExpanded] = useState<boolean>(false);

    return (
        <div className="menu__container" role="menu">
            <div className="menu__header">
                {!isPadStart && (
                    <>
                        {bankLink && (
                            <LinkItem
                                icon={IconTypes.PIL_VENSTRE}
                                className="backToBank"
                                linkType={LinkType.BUTTON_SMALL_NEGATIVE}
                                href={bankLink.url}
                            >
                                {bankLink.name}
                            </LinkItem>
                        )}
                        <SmallButton
                            icon={IconTypes.PIN_KODE_24}
                            buttonType={ButtonTypes.SMALL_NEGATIVE}
                            onClick={logout}
                        >
                            {logoutButtonText}
                        </SmallButton>
                    </>
                )}
            </div>
            <ul className={classNames('menu__list', { no_menu_items: hideMenu })}>
                {isPadStart ? (
                    <>
                        {items?.map((item, i) => (
                            <li
                                role="menuitem"
                                key={item.id ?? item.link.url}
                                className={classNames('menu__item menu__item-header', {
                                    active: item.isActive,
                                })}
                            >
                                <a href={item.link.url} data-focus-first={i === 0 ? true : undefined}>
                                    {item.name} <Icon type={IconTypes.LITEN_PIL_HOEYRE} />
                                </a>
                                {item.submenuItems && (
                                    <ul className="menu__submenu">
                                        {item.submenuItems.map((submenu) => (
                                            <MenuElement key={submenu.id} menuItem={submenu} />
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </>
                ) : (
                    <>
                        {items?.map((item) => (
                            <ExpandableMenuElement item={item} isActive={isExpanded} key={item.id} />
                        ))}
                    </>
                )}
            </ul>
        </div>
    );
};

export default DesktopMenu;
